import React from 'react'

import TextAnswer from 'lemon-campaign-ui/lib/molecules/TextAnswer'

const emptyValue = {}
const textAnswerBox = {
  top: 'small',
  bottom: 'small',
  left: 'none',
  right: 'none',
  bgColor: 'transparent',
}
export default ({ component, defaults, handlers }) => {
  const emoji = !!component.content.showIcon && component.content.icon

  return (
    <TextAnswer
      {...defaults}
      box={textAnswerBox}
      value={component.content.value || emptyValue}
      borderRadius={component.content.borderRadius}
      color={component.content.color}
      bgColor={component.content.backgroundColor}
      size={component.content.size}
      draft={component.content.wysiwyg}
      emoji={emoji}

      clickHandler={() => handlers.answer(component)}

      // link={linking(component)} -- handled via js in templates/page.js
      bouncy
    />
  )
}
